import "./style.css";
import { useEffect, useState } from "react";
import down from "../../../assets/down.svg";
import up from "../../../assets/up.svg";
import upRightArrow from "../../../assets/up-right-arrow-white.svg";
import upRightBlue from "../../../assets/up-right-arrow.svg";

export default function FAQHome() {
  const [open, setOpen] = useState("one");
  const [active, setActive] = useState("pills-general-tab");

  useEffect(() => {
    setOpen("one");
  }, [active]);

  return (
    <div className="d-flex justify-content-center">
      <div className="commonInlinePadding paddingBlockForFAQHome tab-content section-container w-100">
        <div className="faqHomeContainer">
          <div className="off-black faqHuHu">
            Frequently <br />
            Asked Questions
          </div>

          <div
            className={`tab-pane fade faq-section w-100 ${active == "pills-general-tab" ? "show active" : ""
              }`}
            id="pills-general"
            role="tabpanel"
            aria-labelledby="pills-general-tab"
          >
            <div for="one" className="w-100">
              <div
                className="d-flex justify-content-between gap-5 w-100 pointer"
                style={{ justifyContent: "space-between !important" }}
                onClick={() => setOpen(open == "one" ? "" : "one")}
              >
                <div className="off-black extra-large bold">
                  What is Regul8, and how does it benefit CPG businesses?
                </div>

                {open == "one" ? (
                  <div className="up">
                    <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                  </div>
                ) : (
                  <div className="down">
                    <img
                      src={down}
                      alt="down"
                      style={{ width: "0.87106rem", cursor: "pointer" }}
                    />
                  </div>
                )}
              </div>
              {open == "one" ? (
                <div className="right-5 off-black large normal mt-3 " style={{ opacity: 0.6 }}>
                  Regul8 is a software platform that leverages artificial intelligence to help CPG companies optimize their operations, manage regulatory compliance, and make data-driven decisions. It enhances supply chain efficiency, reduces costs, and improves responsiveness to market changes.

                </div>
              ) : null}
            </div>

            <div className=" line mt-1 mb-1" />
            <div for="two" className="w-100">
              <div
                className="d-flex justify-content-between gap-5 w-100 pointer"
                onClick={() => setOpen(open == "two" ? "" : "two")}
              >
                <div className="off-black extra-large bold">
                  How does Regul8 help with regulatory compliance in multiple markets?
                </div>

                {open == "two" ? (
                  <div className="up">
                    <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                  </div>
                ) : (
                  <div className="down">
                    <img
                      src={down}
                      alt="down"
                      style={{ width: "0.87106rem", cursor: "pointer" }}
                    />
                  </div>
                )}
              </div>
              {open == "two" ? (
                <div className="right-5 off-black large normal mt-3" style={{ opacity: 0.6 }}>
                  Regul8 monitors and analyzes regulatory changes across various markets and regions, providing real-time updates and automated alerts. It ensures your business remains compliant by tracking new requirements and streamlining compliance management processes.
                </div>
              ) : null}
            </div>

            <div className=" line mt-1 mb-1" />
            <div for="three" className="w-100">
              <div
                className="d-flex justify-content-between gap-5 w-100 pointer"
                onClick={() => setOpen(open == "three" ? "" : "three")}
              >
                <div className="off-black extra-large bold">
                  What kind of consumer insights does Regul8 provide?
                </div>

                {open == "three" ? (
                  <div className="up">
                    <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                  </div>
                ) : (
                  <div className="down">
                    <img
                      src={down}
                      alt="down"
                      style={{ width: "0.87106rem", cursor: "pointer" }}
                    />
                  </div>
                )}
              </div>
              {open == "three" ? (
                <div className="right-5 off-black large normal mt-3 " style={{ opacity: 0.6 }}>
                  Regul8 analyzes live consumer data to identify trends, preferences, and purchasing behavior. It provides actionable insights that help businesses tailor their marketing strategies, product development, and sales efforts to better meet consumer needs.
                </div>
              ) : null}
            </div>

            <div className=" line mt-1 mb-1" />
            <div for="four" className="w-100">
              <div
                className="d-flex justify-content-between gap-5 w-100 pointer"
                onClick={() => setOpen(open == "four" ? "" : "four")}
              >
                <div className="off-black extra-large bold">
                  Is Regul8 customizable to specific business needs?
                </div>

                {open == "four" ? (
                  <div className="up">
                    <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                  </div>
                ) : (
                  <div className="down">
                    <img
                      src={down}
                      alt="down"
                      style={{ width: "0.87106rem", cursor: "pointer" }}
                    />
                  </div>
                )}
              </div>
              {open == "four" ? (
                <div className="right-5 off-black large normal mt-3 " style={{ opacity: 0.6 }}>
                  Absolutely. Regul8 offers customization options to fit the unique needs of different CPG businesses. It provides a seamless solution that aligns with your organizational goals.
                </div>
              ) : null}
            </div>
            <div className=" line mt-1 mb-1" />

            <div>
              <a href="/faqs" style={{ textDecoration: "none" }}>
                <button
                  className="btn btn-outline-primary buttonText faqButton"
                  style={{ border: "none" }}
                >
                  See All FAQs
                  <div className="btn-icon-container">
                    {" "}
                    <img
                      src={upRightBlue}
                      alt="Arrow"
                      className="icon-default"
                    />
                    <img
                      src={upRightArrow}
                      alt="Arrow"
                      className="icon-hover"
                    />
                  </div>
                </button>{" "}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
